import React from 'react';
import _ from 'lodash';
import PropTypes from 'prop-types';

const AuctionMethodsFeature = ({ data }) => (
  <div className="im-box im-box--white im-box--shadow im-box--height-100p">
    <div className="text-center">
      <svg className="w-60 inline-block">
        <use xlinkHref={data.svgIcon} />
      </svg>
    </div>
    <div className="text-center">
      <span className="fw-900">{data.title}</span>
    </div>
    <div className="im-step-bar3 mt-4">
      <ul className="im-list">
        {_.map(data.descriptions, (description) => (
          <li className="d-flex align-items-center">
            <div>
              <svg className="mr-2 wh-15">
                <use xlinkHref="/image/icons.svg#ic-safemark" />
              </svg>
            </div>
            <div className="p-1 im-step-bar3__item__description text-left">{description}</div>
          </li>
        ))}
      </ul>
    </div>
  </div>
);

AuctionMethodsFeature.propTypes = {
  data: PropTypes.object,
};

export default AuctionMethodsFeature;
